export default function Checkout({title, image, quantity, price, unit }) {
  return (
    <li className="list-group-item px-4 py-3">
      <div className="row align-items-center">
        <div className="col-2 col-md-2">
          <img src={image} alt={title} className="img-fluid rounded"
            style={{
              width: "80px",
              height: "80px",
              objectFit: "cover",
            }} />
        </div>
        <div className="col-5 col-md-5">
          <h6 className="mb-0">{title}</h6>
          <span>
            <small className="text-muted">{unit}</small>
          </span>
        </div>
        <div className="col-2 col-md-2 text-center text-muted">
          <span>{quantity}</span>
        </div>
        <div className="col-3 text-lg-end text-start text-md-end col-md-3">
          <span className="fw-bold">₹{price}</span>
        </div>
      </div>
    </li>
  );
}
